export default theme => ({
  card: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'column',
    width: 400,
    height: 400,
    boxShadow: `10px 5px 40px 20px ${theme.palette.background.dark}`,
    margin: '60px 30px',
  },
  header: {
    backgroundColor: '#7fc7d9',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '80%',
    padding: '5px 10px',
    width: '100%',
    color: theme.palette.common.white,
  },
  body: {
    height: '20%',
    color: theme.palette.common.white,
    padding: '15px',
    whiteSpace: 'normal',
  },
  homeImage: {
    height: 300,
    backgroundSize: 'contain !important',
    backgroundRepeat: 'no-repeat !important',
    backgroundPosition: 'right center !important',
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]: {
      height: 300,
      backgroundSize: 'cover !important',
      backgroundRepeat: 'no-repeat !important',
      backgroundPosition: 'center center !important',
    },
  },
  bannerImage: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      height: 150,
      width: '100%',
      marginTop: '10px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: '60px',
    },
  },
  bannerImage2: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      height: 100,
      display: 'block',
    },
  },
  infoContainer: {
    position: 'absolute',
    top: '0px',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '10px',
  },
  h2: {
    textTransform: 'uppercase',
    fontSize: '30px',
    fontWeight: '600',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem !important',
    },
  },
  showtimes: {
    border: '1px solid #dbdde0',
    borderRadius: '10px',
    color: '#dbdde0',
    padding: '5px 10px',
    marginRight: '15px',
  },

  // Movie card — clean hover
  movieImage: {
   height: 400,
    backgroundSize: 'cover !important',
    backgroundRepeat: 'no-repeat !important',
    backgroundPosition: 'center center !important',
    borderRadius: '12px 12px 0 0',
    transition: 'transform 0.4s ease',
    [theme.breakpoints.down('sm')]: {
      height: '220px',
    },
  },

  movieInfoContainer: {
    position: 'absolute',
    top: '0px',
    width: '100%',
    height: '100%',
    padding: '1rem',
    borderRadius: '12px',
    background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0) 70%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },

  movieTitle: {
    textTransform: 'uppercase',
    fontSize: '15px !important',
    fontWeight: '700 !important',
    color: 'white',
    letterSpacing: '0.5px',
    lineHeight: '1.3 !important',
    textShadow: '0 1px 4px rgba(0,0,0,0.5)',
  },

  language: {
    textTransform: 'capitalize',
    color: '#ccc',
    fontSize: '13px',
    marginTop: '2px',
  },
});